import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';

const influencerItemSelector = item => item;

const filtersSelector = createSelector(
  influencerItemSelector,
  item => (!isEmpty(item) && item.page.topTen.filters
    ? item.page.topTen.filters
    : []),
);

export const topTenFiltersSelector = createSelector(
  filtersSelector,
  topTenFilters => (topTenFilters),
);

export default {
  topTenFiltersSelector,
};
